import { BACKGROUND_COLOR_TYPES } from "../../backend/constants/theme-background-color-types";
import { getInfoColorTheme } from "../../frontend/services/helpers"

export function getBackgroundColor(color) {

  const { type, color1, color2 } = getInfoColorTheme(color);

  switch(type) {
    case BACKGROUND_COLOR_TYPES.SOLID:
      
      return color1

    case BACKGROUND_COLOR_TYPES.ANIMATION:
    case BACKGROUND_COLOR_TYPES.GRADIENT:

      return new fabric.Gradient({
        coords: { x1: 0, y1: 0, x2: 0, y2: 1 },
        gradientUnits: "percentage",
        colorStops: [
          { offset: "0", color: color1 },
          { offset: "1", color: color2 },
        ],
      });

    default:
      
      return color
  }
}